var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulegradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: url(#linear-gradient);\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 6.5,
    x2: 13,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4ee6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.06,12.5h-2.48c-.73,0-1.09,0-1.37-.15-.25-.13-.44-.33-.57-.58-.14-.29-.14-.66-.14-1.41V3.97c0-.75,0-1.12.14-1.41.12-.25.32-.45.57-.58.28-.15.64-.15,1.37-.15h7.56c.73,0,1.1,0,1.37.15.25.13.44.33.57.58.14.29.14.66.14,1.41v1.2M3.11.5v1.33M9.62.5v1.33M.5,4.5h11.73M7.34,7.17H3.11M5.06,9.83h-1.96M7.67,12.5l1.32-.27c.11-.02.17-.04.23-.06.05-.02.09-.04.13-.07.05-.03.09-.08.17-.16l2.71-2.77c.36-.37.36-.97,0-1.33-.36-.37-.94-.37-1.3,0l-2.71,2.77c-.08.09-.12.13-.16.18-.03.04-.05.09-.07.14-.02.05-.03.11-.06.23l-.26,1.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulegradient);
export default __webpack_public_path__ + "static/media/Schedule gradient.7c8add686b26e056b39e6bc3b41b526b.svg";
export { ForwardRef as ReactComponent };